import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  dataViews: [],
  currentDataView: null,
  dataViewItems: [],
  editDataView: false,

  dataViewsLoading: false,
  currentDataViewLoading: false,
  dataViewItemsLoading: false,
  editDataViewLoading: false,
  createDataViewLoading: false,
});

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};
